import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Megapack Psicología Rentable — Construye Progreso™';
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.type = 'image/webp';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp';
document.head.appendChild(preloadImg);
render(<App data-id="element-389" />, document.getElementById('root'));